(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PessoaDeleteController',PessoaDeleteController);

    PessoaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Pessoa', 'Propriedade', 'Pessoapropriedade', 'User'];

    function PessoaDeleteController($uibModalInstance, entity, Pessoa, Propriedade, Pessoapropriedade, User) {
        var vm = this;

        vm.pessoa = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        vm.onSuccess = onSuccess;
        vm.numPropriedades = 0;
        vm.deletar = deletar;
        
        
        vm.id = null;
        vm.login = null;
                
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	
        	vm.id = id;
        	vm.login = vm.pessoa.login;
            Pessoapropriedade.queryPPsAssociadas({idpessoa:id}, onSuccess);
        	
           
        }
        
        function onSuccess(result){
            Pessoapropriedade.acao({acao:"delete"}, result, deletar);   
        }

        function deletar(){
            Pessoa.delete({id: vm.id},
                function () {
                    User.delete({login: vm.login});
                    $uibModalInstance.close(true);
                }
            );
        }
    }
})();
